import React from "react";
import { Box, Spinner as ChakraSpinner } from "@chakra-ui/react";

interface ISpinnerProps {
  loading: boolean;
  bgColor?: string;
  children: React.ReactElement | React.ReactNode;
}

const Spinner: React.FC<ISpinnerProps> = ({
  loading,
  bgColor = "#C10C0D",
  children,
}) => {
  return (
    <>
      <Box
        width="100%"
        height="100%"
        justifyContent="center"
        alignItems="center"
        position="fixed"
        backgroundColor="rgba(255, 255, 255, 0.72)"
        backdropFilter="blur(4px)"
        sx={{ WebkitBackdropFilter: "blur(4px)" }}
        bottom="0"
        left="0"
        top="0"
        right="0"
        zIndex={9999}
        display={loading ? "flex" : "none"}
        transition="opacity 0.2s ease"
      >
        <ChakraSpinner
          emptyColor="gray.200"
          color={bgColor}
          size="lg"
          thickness="3px"
        />
      </Box>
      {children}
    </>
  );
};

export default Spinner;
